<template>
  <a-modal
    v-model:open="visible"
    title="Detalles de integración"
    width="500px"
    centered
    :footer="null"
  >
    <!-- Datos generales -->
    <section class="integration-section" style="margin-top: 15px">
      <h4 class="section-title">Datos generales</h4>
      <div class="integration-date">
        <span class="label">Fecha de integración:</span>
        <span class="value">{{ formattedCreatedAt }}</span>
      </div>
    </section>

    <a-divider 
      style="margin: 18px 0"
    />

    <!-- Permisos -->
    <section class="integration-section">
      <div class="permissions-header">
        <h4 class="section-title">Permisos</h4>
        <small class="updated-at">Actualizado el {{ formattedUpdatedAt }}</small>
      </div>

      <ul class="permissions-list">
        <li v-for="func in integration?.functionalities" :key="func.id">
          <p class="permissions-name">{{ func.name }}</p>
          <ul style="list-style: disc">
            <li v-for="(detail, idx) in func.details" :key="idx" class="permissions-detail">
              {{ detail }}
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- <div class="modal-footer">
      <a-button @click="closeModal">Cerrar detalles</a-button>
    </div> -->
  </a-modal>
</template>

<script setup lang="ts">
import { ref, computed, watch, defineProps, defineEmits } from 'vue'
import dayjs from 'dayjs'
import { IntegrationData } from '@/@types/integrations';

const props = defineProps<{
  modelValue: boolean
  integration: IntegrationData | null
}>()

const emit = defineEmits(['update:modelValue'])

const visible = ref(props.modelValue)
watch(() => props.modelValue, (val) => (visible.value = val))
watch(visible, (val) => emit('update:modelValue', val))

const formattedCreatedAt = computed(() => {
  if (!props.integration?.created_at) return '-'
  return dayjs(props.integration.created_at).format('DD/MM/YYYY [a las] h:mma')
})

const formattedUpdatedAt = computed(() => {
  if (!props.integration?.updated_at) return '-'
  return dayjs(props.integration.updated_at).format('DD/MM/YYYY, h:mma')
})

function closeModal() {
  visible.value = false
}
</script>

<style scoped lang="sass">
.integration-section
  margin-bottom: 20px

.section-title
  font-weight: 600
  font-style: Semibold
  font-size: 16px
  line-height: 24px
  color: rgba(0, 0, 0, 0.88)


.integration-date
  display: flex
  justify-content: space-between
  font-size: 13px

.label
  font-weight: 600
  font-size: 14px
  line-height: 22px
  color: rgba(38, 38, 38, 0.88)

.value
  font-weight: 400
  font-size: 14px
  line-height: 22px
  color: rgba(0, 0, 0, 0.65)

.permissions-header
  display: flex
  justify-content: space-between
  align-items: baseline

.updated-at
  font-weight: 400
  font-style: italic
  font-size: 12px
  line-height: 20px
  color: rgba(0, 0, 0, 0.45)

.permissions
  &-list
    list-style: none
    padding: 0
    margin: 8px 0 0 0
    li
      margin-bottom: 12px
  &-name
    font-weight: 600
    font-size: 14px
    line-height: 22px
    margin-bottom: 2px
    margin-top: 5px

  &-detail
    font-weight: 400
    font-size: 14px
    line-height: 22px
    color: rgba(0, 0, 0, 0.65)
    margin-bottom: 2px

.modal-footer
  margin-top: 20px
  text-align: center
</style>
